import Swiper, { Autoplay, Navigation } from "swiper";

const isHome = document.getElementById('hpHero');
const navMenu = document.querySelector('nav');

if (isHome) {
  window.onload = (function () {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 400) {

        navMenu.classList.add('navScrolldown');
      } else {
        navMenu.classList.remove('navScrolldown');
      }
    })
  })
}


// Nav menu mobile rwd

const btnMob = document.querySelector(".mobile-nav-btn");
const navMobActive = document.querySelector(".nav-mobil-on");

btnMob.addEventListener("click", function () {
  btnMob.classList.toggle("active");
  navMobActive.classList.toggle("active-nav-mob");
});


// EXPERT SWIPER 

var swiper = new Swiper(".mySwiper", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    550: {
      slidesPerView: 2,
      spaceBetween: 14,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 18,
    },
  },
});

const googleContainer = document.querySelector('.hp__avis__wrapper')

setTimeout(() => {
  googleContainer.childNodes[3].childNodes[0].childNodes[0].childNodes[2].style.visibility = 'hidden';
}, "2500")